import { Sparkles, type LucideIcon } from "lucide-react"
import type { ReactNode } from "react"
import { cn } from "@/lib/utils"

type AgentColumnHeaderProps = {
  title: string
  icon?: LucideIcon
  /** Готовая иконка вместо `icon` — например, иконка активной вкладки колонки; `null` — без иконки. */
  iconNode?: ReactNode
  toolbar?: ReactNode
  className?: string
}

/** Высота и линия шапки колонки — общие для шапок, которые собраны без этого компонента. */
export const AGENT_COLUMN_HEADER_CLASS = "flex shrink-0 items-center gap-2 border-b border-ui-border px-3 py-2.5"

/** Шапка боковой колонки: цветная иконка, подпись и линия на всю ширину. */
export function AgentColumnHeader({
  title,
  icon: Icon = Sparkles,
  iconNode,
  toolbar,
  className,
}: AgentColumnHeaderProps) {
  return (
    <div className={cn("agent-column-header", AGENT_COLUMN_HEADER_CLASS, className)}>
      <div className="flex min-w-0 items-center gap-2">
        {iconNode === undefined ? (
          <Icon className="h-3.5 w-3.5 shrink-0 text-ui-accent" />
        ) : iconNode ? (
          <span className="flex shrink-0 text-ui-accent [&_svg]:h-3.5 [&_svg]:w-3.5">{iconNode}</span>
        ) : null}
        <span className="truncate text-xs font-medium text-ui-text-primary">{title}</span>
      </div>
      {toolbar ? <div className="ml-auto flex min-w-0 shrink-0 flex-wrap items-center gap-2">{toolbar}</div> : null}
    </div>
  )
}
